import React from 'react';
import { X } from 'lucide-react';

export const ANNOUNCEMENT_HEIGHT = 44;

// Slim bar above the menu. Sits in normal page flow (not fixed), so it never covers content.
// The visitor can close it with the round button on the right; the choice is remembered for seven days.
export default function AnnouncementBar({ onOpen, onClose }) {
  return (
    <div
      className="w-full text-white flex items-center justify-center relative"
      style={{ height: ANNOUNCEMENT_HEIGHT, paddingLeft: 12, paddingRight: 52, background: 'linear-gradient(90deg,#14301A 0%,#1E4A26 50%,#14301A 100%)', fontFamily: "'Outfit', sans-serif" }}
    >
      <style>{`@keyframes annPulse{0%,100%{box-shadow:0 0 0 0 rgba(244,160,100,.7)}60%{box-shadow:0 0 0 7px rgba(244,160,100,0)}}@media (prefers-reduced-motion:reduce){.ann-dot{animation:none!important}}`}</style>
      <p className="flex items-center gap-2 sm:gap-3 text-[13px] sm:text-sm leading-tight m-0 min-w-0">
        <span className="ann-dot inline-block w-2 h-2 rounded-full bg-[#F4A064] shrink-0" style={{ animation: 'annPulse 2s ease-out infinite' }} aria-hidden="true" />
        <span className="font-semibold truncate">
          <span className="sm:hidden">Free MbuziPlus lesson</span>
          <span className="hidden sm:inline">Free MbuziPlus lesson. Try it in 5 to 20 minutes, no sign-in.</span>
        </span>
        <button onClick={onOpen} className="shrink-0 rounded-full bg-[#BF4700] px-3.5 py-1 font-bold text-white hover:bg-[#A33C00] whitespace-nowrap">
          Try it free &rarr;
        </button>
      </p>
      <button
        onClick={onClose}
        aria-label="Close announcement"
        title="Close"
        className="absolute right-2 top-1/2 -translate-y-1/2 w-9 h-9 flex items-center justify-center rounded-full border border-white/30 hover:bg-white/15"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
